<template>
  <v-container>
    <div
      v-if="isLoading"
      class="d-flex justify-center align-center"
      style="height: 100vh;"
    >
      <v-progress-circular
        indeterminate
        color="#2661FF"
        size="80"
      ></v-progress-circular>
    </div>
    <div v-else>
      <v-row class="px-2">
        <v-col cols="12" md="6">
          <div
            class="text-h6 grey--text text--darken-3 font-weight-medium mb-2 ml-6"
            style="font-size: 20px !important;"
          >
            <v-btn text @click="returnIndex">
              <v-icon>chevron_left</v-icon>
            </v-btn>
            {{ $t('pricing_model.title') }}
          </div>
          <v-breadcrumbs
            divider=">"
            :items="breadcrumbItems"
            class="py-2"
          ></v-breadcrumbs>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card class="rounded-lg" flat>
            <v-card-title class="justify-center">
              <p class="mt-2" style="color: #2661FF;">
                {{ $t('pricing_model.create.title') }}
              </p>
            </v-card-title>
            <v-card-text class="pa-0 ma-0">
              <v-row class="d-flex justify-center align-center">
                <v-col cols="12">
                  <v-stepper
                    alt-labels
                    class="elevation-0"
                    v-model="currentStep"
                  >
                    <v-row>
                      <v-col cols="12">
                        <v-stepper-header
                          class="elevation-0"
                          style="max-width: 70%; margin: 0 auto;"
                        >
                          <template v-for="(step, index) in steps">
                            <v-stepper-step
                              :step="index + 1"
                              color="#2661FF"
                              :complete="
                                currentStep > index + 1 || isLastStep()
                              "
                            >
                              <div
                                class="d-flex flex-column justify-center align-center"
                                style="width: 150px;"
                                :class="GetTextColor(index + 1)"
                              >
                                <span class="body-2">{{ step.title }}</span>
                                <span class="subtitle-1">{{
                                  step.description
                                }}</span>
                              </div>
                            </v-stepper-step>
                            <v-divider
                              class="mt-10"
                              v-if="index + 1 !== steps.length"
                              :key="index"
                            ></v-divider>
                          </template>
                        </v-stepper-header>
                      </v-col>
                    </v-row>

                    <v-stepper-items class="elevation-0">
                      <v-stepper-content
                        class="elevation-0"
                        v-for="(step, index) in steps"
                        :key="index"
                        :step="index + 1"
                      >
                        <component
                          v-if="currentStep === index + 1"
                          :is="getComponentForStep(index + 1)"
                          :step="step"
                          @nextStep="nextStep"
                          @backStep="backStep"
                        />
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Step1 from '@/components/PricingModels/Create/Step1'
import Step2 from '@/components/PricingModels/Create/Step2'
import Step3 from '@/components/PricingModels/Create/Step3'

export default {
  name: 'organizationPricingModelsCreate',
  components: { Step1, Step2, Step3 },
  data() {
    return {
      isLoading: false,
      currentStep: 1,
      breadcrumbItems: [
        { text: this.$t('organization.title'), disabled: true },
        {
          text: this.$t('pricing_model.title'),
          disabled: false
        }
      ],
      steps: [
        {
          title: this.$t('pricing_model.create.steps.step_1.title'),
          description: this.$t('pricing_model.create.steps.step_1.description')
        },
        {
          title: this.$t('pricing_model.create.steps.step_2.title'),
          description: this.$t('pricing_model.create.steps.step_2.description')
        },
        {
          title: this.$t('pricing_model.create.steps.step_3.title'),
          description: this.$t('pricing_model.create.steps.step_3.description')
        }
      ]
    }
  },
  computed: {
    ...mapState({
      pricingModel: ({ pricingModels: { pricingModel } }) => pricingModel
    })
  },
  methods: {
    ...mapMutations({
      setPricingModel: 'pricingModels/setPricingModel',
      resetPricingModel: 'pricingModels/resetPricingModel'
    }),
    getComponentForStep(step) {
      switch (step) {
        case 1:
          return 'Step1'
        case 2:
          return 'Step2'
        case 3:
          return 'Step3'
      }
    },
    nextStep(data) {
      const pricingModel = data && data.pricingModel ? data.pricingModel : null
      const step = data && data.step ? data.step : null

      switch (step) {
        case 1:
          this.setPricingModel(pricingModel)
          this.currentStep++
          break
        case 2:
          this.currentStep++
          break
        case 3:
          this.currentStep = 1
          break
      }
    },
    backStep() {
      this.currentStep -= 1
    },
    GetTextColor(index) {
      if (this.currentStep >= index) {
        return 'primary_color'
      } else {
        return
      }
    },
    returnIndex() {
      this.$router.replace({ name: 'organizationPricingModels' })
      this.resetPricingModel()
    },
    isLastStep() {
      return this.currentStep === this.steps.length
    }
  }
}
</script>

<style lang="scss" scoped>
.primary_color {
  color: #2661ff;
}

::v-deep .v-stepper__step__step {
  width: 35px;
  height: 35px;
}
</style>
